import React, { PureComponent } from 'react';
import {
  View, Text, StyleSheet, Platform, Clipboard,
} from 'react-native';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import { ProgramType } from 'fitbeat.models';
import { connect } from 'react-redux';
import { ChevronRightIcon } from './Icons';
import Theme from '../../theme';
import { isRequired, minLength3, UserDataConsumer } from '../../utils';
import { TextInput, showMessage } from '../../ui';
import {
  Button, Heading, HeadingTypes, ButtonTypes,
} from '../../components';
import { orderMealsOpen } from '../../Nutrition/actions';
import { defaultScale } from '../../utils/scaling';
import { openInAppWebViewerInBackground } from '../../utils/inAppWebViewer';
import { openLink } from '../../utils/linkUtils';

class CouponCopyWithButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      coupon: props.t('oderMealCoupon'),
    };
  }

  componentDidMount() {
    this.initializeForm();
  }

  initializeForm = () => {
    const { initialize } = this.props;
    initialize({ copyCoupon: this.state.coupon });
  };

  openUrl = async (url) => {
    const isWeb = Platform.OS === 'web';
    if (isWeb) {
      window.open(url, '_blank');
      return;
    }
    await openLink(url);
  };

  copyCoupon = () => {
    Clipboard.setString(this.state.coupon);
    showMessage('Coupon copied to clipboard');
  };

  orderNow = async () => {
    const { longTermGoal, orderMealsOpen } = this.props;
    const baseUrl = 'https://www.mymusclechef.com/goalbased';
    const utms = 'utm_medium=referral&utm_source=app&utm_campaign=fitbeat-partnership';

    if (ProgramType.GainMuscleAndStrengthGoal === longTermGoal) {
      openInAppWebViewerInBackground(`${baseUrl}/musclegain/?${utms}`);
    } else if (ProgramType.GetLeanAndFitGoal === longTermGoal) {
      openInAppWebViewerInBackground(`${baseUrl}/weightloss/?${utms}`);
    } else if (ProgramType.GetStrongAndFitGoal === longTermGoal) {
      openInAppWebViewerInBackground(`${baseUrl}/caloriecontrol/?${utms}`);
    } else if (ProgramType.MobilityAndTone === longTermGoal) {
      openInAppWebViewerInBackground(`${baseUrl}/weightloss?${utms}`);
    } else if (ProgramType.MuscleAndShred === longTermGoal) {
      openInAppWebViewerInBackground(`${baseUrl}/musclegain/?${utms}`);
    } else {
      openInAppWebViewerInBackground(`${baseUrl}/caloriecontrol/?${utms}`);
    }
    orderMealsOpen();
  };

  render() {
    return (
      <View style={styles.mainContainer}>
        <Button
          title='Order Now'
          fontColor={Theme.WHITE}
          buttonType={ButtonTypes.NORMAL}
          onPress={this.orderNow}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    padding: defaultScale(10),
  },
  headingWithIconContainer: {
    flexDirection: 'row',
    paddingVertical: 5,
  },
  heading: {
    color: Theme.WHITE,
    fontFamily: Theme.Custom700,
    fontSize: 20,
    textAlign: 'left',
  },
  iconContainer: {
    paddingHorizontal: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: Theme.Custom400,
    color: Theme.GREY_LIGHT,
    paddingVertical: 5,
    paddingBottom: 10,
  },
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { user: { nutritionService } } = ownProps;
  return {
    orderMealsOpen: () => dispatch(orderMealsOpen()),
  };
};

CouponCopyWithButton = translate(['nutrition'], { wait: true })(CouponCopyWithButton);
CouponCopyWithButton = UserDataConsumer(connect(null, mapDispatchToProps)(CouponCopyWithButton));
export default reduxForm({ form: 'CopyCoupon' })(CouponCopyWithButton);
